import React, { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  Switch,
  Divider,
} from '@mui/material';
import {
  ArrowLeftIcon,
  BellIcon,
  RadioCheckedIcon,
  RadioIcon,
} from '../../components/shared/CustomIcons';

const NotificationsComponent = () => {
  const [notificationMethod, setNotificationMethod] = useState('Email');
  const [messagesEnabled, setMessagesEnabled] = useState(true);
  const [newTaskEnabled, setNewTaskEnabled] = useState(false);
  const [newResourcesEnabled, setNewResourcesEnabled] = useState(true);

  const handleNotificationMethodChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setNotificationMethod((event.target as HTMLInputElement).value);
  };

  return (
    <Box sx={{ bgcolor: 'grey.50', px: 3, py: 8 }} className="flex-1">
      <Box sx={{ mb: 4 }} className="d-flex align-items-center">
        <IconButton
          aria-label="back"
          sx={{ p: 0 }}
          onClick={() => history.back()}
        >
          <ArrowLeftIcon sx={{ fontSize: 40, color: 'text.primary' }} />
        </IconButton>
        <Box
          sx={{ gap: 1.5, ml: -5 }}
          className="d-flex justify-content-center align-items-center flex-1"
        >
          <BellIcon sx={{ color: 'tertiary.main', width: 24, height: 24 }} />
          <Typography variant="h6" sx={{ color: 'grey.900' }}>
            Notifications
          </Typography>
        </Box>
      </Box>
      <FormControl>
        <Typography sx={{ color: 'grey.900', fontWeight: 600, mb: 3 }}>
          How would you prefer to receive notifications?
        </Typography>
        <RadioGroup
          aria-label="notification-method"
          value={notificationMethod}
          onChange={handleNotificationMethodChange}
          sx={{ gap: 2.25 }}
        >
          <FormControlLabel
            value="Email"
            control={
              <Radio icon={<RadioIcon />} checkedIcon={<RadioCheckedIcon />} />
            }
            label="Email"
          />
          <FormControlLabel
            value="SMS"
            control={
              <Radio icon={<RadioIcon />} checkedIcon={<RadioCheckedIcon />} />
            }
            label="SMS"
          />
        </RadioGroup>
      </FormControl>
      <Divider sx={{ borderColor: 'solitude.main', my: 3 }} />
      <Box sx={{ gap: 2, mb: 1.25 }} className="d-flex align-items-center">
        <Typography
          sx={{ fontWeight: 600, color: 'grey.900' }}
          className="flex-1"
        >
          Messages
        </Typography>
        <Switch
          checked={messagesEnabled}
          onChange={(e) => setMessagesEnabled(e.target.checked)}
          color="tertiary"
        />
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Receive notifications for new messages from Stoneygate Eye Hospital
      </Typography>
      <Divider sx={{ borderColor: 'solitude.main', my: 3 }} />
      <Box sx={{ gap: 2, mb: 1.25 }} className="d-flex align-items-center">
        <Typography
          sx={{ fontWeight: 600, color: 'grey.900' }}
          className="flex-1"
        >
          New task
        </Typography>
        <Switch
          checked={newTaskEnabled}
          onChange={(e) => setNewTaskEnabled(e.target.checked)}
          color="tertiary"
        />
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Receive notifications when a new task is assigned
      </Typography>
      <Divider sx={{ borderColor: 'solitude.main', my: 3 }} />
      <Box sx={{ gap: 2, mb: 1.25 }} className="d-flex align-items-center">
        <Typography
          sx={{ fontWeight: 600, color: 'grey.900' }}
          className="flex-1"
        >
          New resources
        </Typography>
        <Switch
          checked={newResourcesEnabled}
          onChange={(e) => setNewResourcesEnabled(e.target.checked)}
          color="tertiary"
        />
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Receive notifications when new resources and exercises for eye health
        are added to the platform
      </Typography>
    </Box>
  );
};

export default NotificationsComponent;
